// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3kqOy","label":"Section_label__IpORt","contentWrap":"Section_contentWrap__1REkQ","footer":"Section_footer__elRIq","footerInner":"Section_footerInner__2s-QZ"};